import React from 'react';
import { useTranslation } from 'react-i18next';
import { Smartphone, ArrowLeft } from 'lucide-react';

interface MobileAppViewProps {
    onBack: () => void;
}

export const MobileAppView: React.FC<MobileAppViewProps> = ({ onBack }) => {
    const { t } = useTranslation('dashboard');

    return (
        <div className="max-w-4xl mx-auto space-y-8 animate-fadeIn">
            {/* Header with Back Button */}
            <div className="flex items-center gap-4">
                <button
                    onClick={onBack}
                    className="p-2 hover:bg-slate-100 rounded-full transition text-slate-500"
                >
                    <ArrowLeft size={24} />
                </button>
                <h1 className="text-2xl font-bold font-display text-slate-900 flex items-center gap-2">
                    <Smartphone size={28} className="text-blue-600" /> {t('mobile_app.title')}
                </h1>
            </div>

            <div className="bg-white rounded-3xl border border-slate-200 shadow-xl overflow-hidden">
                <div className="grid grid-cols-1 md:grid-cols-2">

                    {/* Left Column: Context & Buttons */}
                    <div className="p-8 md:p-12 flex flex-col justify-center bg-gradient-to-br from-slate-50 to-white">
                        <div className="mb-8">
                            <h2 className="text-3xl font-bold text-slate-900 mb-4 leading-tight">
                                {t('mobile_app.banner_text')}
                            </h2>
                            <p className="text-lg text-slate-600">
                                {t('mobile_app.subtitle')}
                            </p>
                        </div>

                        <div className="space-y-6">
                            <div>
                                <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-4">
                                    {t('mobile_app.or_download')}
                                </h3>
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <a href="https://apps.apple.com/app/id6758147041" target="_blank" rel="noopener noreferrer" className="transition hover:opacity-80">
                                        <img
                                            src="/assets/app-store-badge.png"
                                            alt={t('mobile_app.ios_btn')}
                                            className="h-14 w-auto"
                                        />
                                    </a>
                                    {/* <a href="#" className="transition hover:opacity-80">
                                        <img
                                            src="/assets/google-play-badge.png"
                                            alt={t('mobile_app.android_btn')}
                                            className="h-14 w-auto"
                                        />
                                    </a> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: QR Code */}
                    <div className="p-8 md:p-12 bg-blue-600 text-white flex flex-col items-center justify-center text-center relative overflow-hidden">
                        {/* Blob decorations */}
                        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2"></div>
                        <div className="absolute bottom-0 left-0 w-64 h-64 bg-indigo-500 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-y-1/2 -translate-x-1/2"></div>

                        <div className="relative z-10">
                            <div className="bg-white p-4 rounded-3xl shadow-2xl mb-6 inline-block transform transition hover:scale-105 duration-300">
                                <img
                                    src="/assets/AccountFlow_App_for_iOS.svg"
                                    alt="QR Code"
                                    className="w-48 h-48 md:w-56 md:h-56"
                                />
                            </div>
                            <h3 className="text-xl font-bold mb-2">{t('mobile_app.scan_qr')}</h3>
                            <p className="text-blue-100 max-w-xs mx-auto">
                                {t('mobile_app.scan_desc')}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};
